/* eslint-disable max-len */
/* eslint-disable fp/no-mutating-methods */
import { Swiper, SwiperSlide } from 'swiper/react'
import { Keyboard, Mousewheel, Navigation, Pagination } from 'swiper'
import Typography from '@mui/material/Typography'

import { concat, flatten, mergeDeepWith } from 'ramda'
import { useAppSelector } from 'src/store/hooks'
import {
  selectManySectionsById,
  selectAssignments,
  selectManyCoursesByIdGroupedBySection,
} from 'src/v3/self-paced/self-paced.slice'
import { ReactElement } from 'react'
import { useMediaQuery } from '@mui/material'
import { useNavigate } from 'react-router-dom'

export default (): ReactElement => {
  let navigate = useNavigate()
  let assignments = useAppSelector(selectAssignments)
  let courses = useAppSelector(
    selectManyCoursesByIdGroupedBySection(assignments),
  )
  let sections = useAppSelector(
    selectManySectionsById(
      flatten(Object.values({ ...courses }))
        .filter((x) => x !== undefined)
        .map((x) => x.sectionID),
    ),
  )
  let largeScreen = useMediaQuery('(min-width:1000px)')

  return (
    <>
      <img
        style={{ width: '100%' }}
        src={`${import.meta.env.VITE_CLOUDFRONT_URL}/public/Assignments.png`}
      />
      {sections?.map((section) => (
        <div className="mt-4" key={section.id}>
          <div className="flex">
            <Typography
              variant="h5"
              className="py-2 ml-2"
              style={{ color: 'white', fontFamily: 'smileAndWave' }}
            >
              {section.name}
            </Typography>
          </div>
          <Swiper
            cssMode={true}
            navigation={true}
            mousewheel={true}
            slidesPerView={largeScreen ? 5 : 3}
            spaceBetween={10}
            slidesPerGroup={2}
            modules={[Navigation, Pagination, Mousewheel, Keyboard]}
            className="netflix-slider"
          >
            {(
              mergeDeepWith(concat, [], courses)?.[(section as any).id] as any
            )?.map((item: any) => (
              <SwiperSlide key={item.id}>
                <img
                  style={{ cursor: 'pointer' }}
                  onClick={() => navigate(`/self-paced/course/${item.id}`)}
                  src={`${import.meta.env.VITE_CLOUDFRONT_URL}/public/${item.imageName}`}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      ))}
    </>
  )
}
